import React from 'react';
import ControlPanel from './controlPanel/ControlPanel';
import { Switch, Route, Redirect } from 'react-router-dom';
import styles from './statistics.css';
import QuestionStatisticsAsync from './question/QuestionStatisticsAsync';
import CountryStatisticsAsync from './countryStatistics/CountryStatisticsAsync';
import OverallStatisticsAsync from './overallStatistics/OverallStatisticsAsync';

const Statistics = React.memo( () => {
    return (
        <div className={ styles.wrapper }>
            <ControlPanel/>
            <Switch>
                <Route
                    path='/calendar/:calendarID/statistics/overall'
                    component={ OverallStatisticsAsync }
                />
                <Route
                    path='/calendar/:calendarID/statistics/questions'
                    component={ QuestionStatisticsAsync }
                />
                <Route
                    path='/calendar/:calendarID/statistics/country'
                    component={ CountryStatisticsAsync }
                />
                <Redirect from='/calendar/:calendarID/statistics/*' to='/404'/>
            </Switch>
        </div>
    );
} );

export default Statistics;

